// extracted by mini-css-extract-plugin
export default {"root":"fPlsqcxk5IOYGfWJ90c2","inner":"_TxYyKLSudnpgaeeaVIk","label":"TnltQm3t5YZFTY5yg_u_","section":"I7UkjKUoDR1hZWdk8bSz"};